import { LogFirebase } from "../../../../../services/firestore";
import { isScreenshareTrack } from "../../../ScreenShare/ScreenShareUtils";
import flashService from "../../../../../services/flashService";
import { dualStreamEnabled } from "../../../../../shared/utility";
import { CALL_DATA } from "../../../../../constants/PublicVariables";
import { updateStreamingStatusOnEvent } from "../../../videoScreenShareOverrideFunction";

export const localTrackPublication = (track) => {
    LogFirebase("TwilioEvents", "Localparticipant_trackPublished", { track_details: track.kind });

    if (isScreenshareTrack(track.track) && dualStreamEnabled()) {
        const params = {
            isVideo: false,
            identity: CALL_DATA.localIdentity,
            isScreenShare: true,
            isLocalUser: true,
        };
        updateStreamingStatusOnEvent(params.isVideo, params.identity, params.isScreenShare, params.isLocalUser); // update streaming identity
    }

    if (track.kind == "video" && !isScreenshareTrack(track.track)) {
        flashService.handleFlashTrack();
    }
};
